import { render, staticRenderFns } from "./TestTube.vue?vue&type=template&id=5ec8723d"
import script from "./TestTube.vue?vue&type=script&lang=js"
export * from "./TestTube.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports